/**
 * EDIT ESTABLISHMENT
 */
import { t } from "i18next"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { useState } from "react"
import establishmentStore from "../model/establishment.store"
import EstablishmentCard from "./EstablishmentCard"
import EstablishmentFormModal from "./modals/EstablishmentFormModal"
import { toast } from "react-toastify"
import PageHeader from "@/components/page-header"
import Button from "@/components/button"
import { useNavigate } from "react-router"
import { faDownload } from "@fortawesome/free-solid-svg-icons"

export default function EstablishmentConfig() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const _session = useAppSelector((state) => state._session)
  const establishment = useAppSelector(establishmentStore.selectors.active)
  const status = useAppSelector(establishmentStore.selectors.status)
  const [modal, setModal] = useState<"MODAL_EDIT" | null>(null)

  const handleSave = async () => {
    if (!establishment.name) {
      toast(t("Le nom de l'établissement ne peut pas être vide"))
      return
    } else {
      const establishment = await dispatch(establishmentStore.thunks.updateEntity()).unwrap()
      dispatch(establishmentStore.actions.replace(establishment))
      setModal(null)
    }
  }

  return (
    <>
      <PageHeader
        title="Établissement"
        subtitle={
          <div className="flex items-center">
            {t("Modifiez les informations propres à l'établissement et nommez les contributeurs au document unique.")}
            {_session.connectedAsSupervisor ? (
              <div className="flex ml-auto">
                <Button
                  isWithBorder
                  className="med"
                  onClick={() => navigate("/risks/import")}
                  isFullWidth
                  icon={faDownload}>
                  {t("Importer mes données")}
                </Button>
              </div>
            ) : null}
          </div>
        }
      />

      {modal === "MODAL_EDIT" && (
        <EstablishmentFormModal status={status} onSave={handleSave} onClose={() => setModal(null)} />
      )}

      <EstablishmentCard establishment={establishment} onEdit={() => setModal("MODAL_EDIT")} />
    </>
  )
}
